import { useDispatch, useSelector } from "react-redux";
import useIsFirstRender from "../../hooks/useIsFirstRender";
import { locationSlice } from "../Location/locationReducer";
import { LOCATION_NAMES } from "../Location/locationConstants";
import { getIsLocationPlatformMobileSelector } from "../Location/locationSelectors";

function useFirstStartIntroRedirect() {
    const isFirstRender = useIsFirstRender();
    const isMobilePlatform = useSelector(getIsLocationPlatformMobileSelector);
    const dispatch = useDispatch();

    if (isMobilePlatform && isFirstRender) {
        const isFirstStartIntroSeen = localStorage.getItem('isFirstStartIntroSeen');
        if (!isFirstStartIntroSeen) {
            localStorage.setItem('isFirstStartIntroSeen', 'true');
            dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.FIRST_START }));
        }
    }

    return null;
}

export default useFirstStartIntroRedirect;
